export enum UserRole {
  TD_ADMIN = 'ROLE_TD_ADMIN',
  SUPERVISOR = 'ROLE_SUPERVISOR',
  SUPERVISOR_LEAD = 'ROLE_SUPERVISOR_LEAD',
  OFFICER = 'ROLE_OFFICER',
  DEPARTMENT_ADMIN = 'ROLE_DEPARTMENT_ADMIN',
  CIVILIAN = 'ROLE_CIVILIAN',
}
